import { stepTypes } from '../../constants/data-types';
import { fields, createSchema, validate as _validate } from '..';

const {
  requiredText,
  thingsContent,
  sectionsContent,
  optionalText,
  optionalArrayOfOptionalString,
  videoLinkType,
} = fields;

const volunteerDefault = createSchema({
  title: requiredText,
  description: requiredText,
  thingsYouWillNeed: thingsContent,
  thingsThatMightBeUseful: thingsContent,
  whatHappensInThisStage: thingsContent,
  whatWillHappenNext: thingsContent,
  topTip: optionalText,
  otherTips: optionalArrayOfOptionalString,
  videoLink: videoLinkType,
});

const volunteerQuestion = createSchema({
  title: requiredText,
  description: requiredText,
  sections: sectionsContent,
  topTip: optionalText,
  otherTips: optionalArrayOfOptionalString,
  videoLink: videoLinkType,
});

const validate = (questionType, data) => {
  if (questionType === stepTypes.DEFAULT) {
    return _validate(volunteerDefault, data);
  } else {
    return _validate(volunteerQuestion, data);
  }
};

export default validate;
